__turbopack_context__.v({
  "slider": "TextMarquee-module-scss-module__QS7VGa__slider",
  "textMarquee": "TextMarquee-module-scss-module__QS7VGa__textMarquee",
});
